/* eslint-disable */
/**
 * 工具方法模块
 * @author  zhengchao
 * @Date 2017-05-09
 */
import { okGlobal } from '@ok/blade';
import { Message } from '@ok/okd';

const { toString } = Object.prototype;
const { ont = {} } = window.utils;

const pbkdf2Param = {
  salt: 'okexisnumberone',
  iterations: 2000,
  keyLenBytes: 32,
};

const normalVerifyMethodEnum = {
  EMAIL: 1,
  SMS: 2,
  GOOGLE: 3,
  TRADEPASSWORD: 4,
  LOGINPASSWORD: 5,
};

const foundElement = (array, target) => {
  return array?.includes(target);
};

const { LOGINPASSWORD, TRADEPASSWORD, EMAIL, GOOGLE, SMS } =
  normalVerifyMethodEnum;

export default {
  isObject(obj) {
    return toString.call(obj) === '[object Object]';
  },
  isArray(obj) {
    return toString.call(obj) === '[object Array]';
  },

  objToQueryString(obj) {
    if (!obj) {
      return '';
    }
    const str = [];
    for (const p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
      }
    }
    return str.join('&');
  },
  /**
   * 格式化timestamp
   * @param  timestamp
   * @param  {string} format    格式字符串, 如 yyyy-MM-dd, yyyy-MM-dd hh:mm:ss
   * @return {string}           格式化后的字符串
   */
  formatTimestamp(timestamp, format) {
    const inputDate = new Date(timestamp);
    const date = {
      'M+': inputDate.getMonth() + 1,
      'd+': inputDate.getDate(),
      'h+': inputDate.getHours(),
      'm+': inputDate.getMinutes(),
      's+': inputDate.getSeconds(),
      'q+': Math.floor((inputDate.getMonth() + 3) / 3),
      'S+': inputDate.getMilliseconds(),
    };
    if (/(y+)/i.test(format)) {
      format = format.replace(
        RegExp.$1,
        inputDate
          .getFullYear()
          .toString()
          .substr(4 - RegExp.$1.length)
      );
    }
    for (const k in date) {
      if (new RegExp(`(${k})`).test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? date[k]
            : `00${date[k]}`.substr(`${date[k]}`.length)
        );
      }
    }
    return format;
  },

  /** *
   * 获取devId  登录注册时用到
   */
  getDeviceId() {
    if (window.localStorage) {
      const { ont } = window.utils;
      let devId = ont.getDeviceId();
      if (!devId) {
        devId = _uuid();
        localStorage.setItem('devId', devId);
      }
      return devId;
    }

    function _uuid() {
      let d = Date.now();
      if (
        typeof performance !== 'undefined' &&
        typeof performance.now === 'function'
      ) {
        d += performance.now(); // use high-precision timer if available
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
    }
  },

  /**
   * 获取url 参数
   * @param name
   * @returns {*}
   */
  getUrlParam(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },

  // 该方法用来 避免 解析html  时带来的 xss攻击 危害
  escape(str) {
    return str
      .replace(/\<br\/\>/g, '\n')
      .replace(/[<>"]/g, (match) => {
        switch (match) {
          case '<':
            return '&lt;';
          case '>':
            return '&gt;';
          case '&':
            return '&amp;';
          case '"':
            return '&quot;';
        }
      })
      .replace(/\n/g, '<br/>');
  },

  deepCopy(obj) {
    try {
      // 终止条件，如果不是对象就放回该值
      if (typeof obj !== 'object' || obj === null) {
        return obj;
      }
      const newObj = obj.constructor === Array ? [] : {};
      Object.keys(obj).forEach((key) => {
        // 利用递归的方式
        newObj[key] = this.deepCopy(obj[key]);
      });
      return newObj;
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  /**
   * 浅拷贝
   * @param obj
   */
  shallowCopy(obj) {
    const newobj = {};
    if (obj) {
      const keys = Object.keys(obj);
      keys.forEach((item) => {
        newobj[item] = obj[item];
      });
    }
    return newobj;
  },

  deepMerge(target, other) {
    if (this.isObject(target) && this.isObject(other)) {
      for (let [key, val] of Object.entries(other)) {
        if (!target[key]) {
          target[key] = val;
        } else {
          target[key] =
            typeof val === 'object' ? this.deepMerge(target[key], val) : val;
        }
      }
    } else if (this.isArray(target) && this.isArray(other)) {
      for (let [key, val] of Object.entries(other)) {
        if (target[key]) {
          target[key] =
            typeof val === 'object' ? this.deepMerge(target[key], val) : val;
        } else {
          target.push(val);
        }
      }
    }
    return target;
  },

  /**
   * 浏览器判断
   * @returns {boolean}
   */
  lessThanIE11() {
    const UA = navigator.userAgent;
    const isIE = UA.indexOf('MSIE') > -1;
    const v = isIE ? /\d+/.exec(UA.split(';')[1]) : 11;
    return v < 11;
  },

  //secondCheckDialog control scroll
  handleBodyScroll({ disabled }) {
    if (disabled) {
      document.getElementsByTagName('body')[0].style.height = '100%';
    } else {
      document.getElementsByTagName('body')[0].style.overflow = null;
    }
  },

  /**
   * 获取 慢hash加密 配置
   */
  getPbkdf2Param() {
    return pbkdf2Param;
  },

  /**
   * 判断一级域名及顶级域名与当前url是否相等
   * @param url
   */
  firstLevelDomainEqual(url) {
    const local = window.location.href;
    const urlHasDomain = url.includes('//');

    // 不存在域名则为同域名
    if (!urlHasDomain) {
      return true;
    }
    // 去掉http 去掉 path 去掉端口 按点切分
    const localDomainList = local
      .split('//')[1]
      .split('/')[0]
      .split(':')[0]
      .split('.');
    const urlDomainList = url
      .split('//')[1]
      .split('/')[0]
      .split(':')[0]
      .split('.');

    // 顶级域名相等
    const topDomainEqual =
      localDomainList[localDomainList.length - 1] ===
      urlDomainList[urlDomainList.length - 1];
    // 一级域名相等
    const firstDomainEqual =
      localDomainList[localDomainList.length - 2] ===
      urlDomainList[urlDomainList.length - 2];

    return topDomainEqual && firstDomainEqual;
  },

  get isJP() {
    return okGlobal.locale === 'ja_JP';
  },

  /**
   *
   * @param {HTMLElement} element
   * @param {'smooth' | 'instant' | 'auto'} behavior
   */
  scrollElementIntoView(element, behavior) {
    const scrollTop = window.scrollY || element.scrollTop;

    // Furthermore, if you have for example a header outside the iframe
    // you need to factor in its dimensions when calculating the position to scroll to
    const headerOutsideIframe =
      window.parent.document.getElementById('newHeader').clientHeight;

    const finalOffset =
      element.getBoundingClientRect().top + scrollTop - headerOutsideIframe;

    setTimeout(() => {
      window.parent.scrollTo({
        top: finalOffset,
        behavior: behavior || 'auto',
      });
    }, 300);
  },

  get isLogin() {
    return ont?.isLogin() || false;
  },

  verifyForward(forward) {
    if (!forward) {
      return false;
    }
    const blackList = ['null', 'undefined', '/login', '//', 'script'];
    let verify = true;

    for (let char of blackList) {
      if (!verify) {
        break;
      }
      verify = !forward.includes(char);
    }

    return verify;
  },

  getAssetsImg(dir, name) {
    return `${okGlobal.cdnBaseUrl}/cdn/assets/imgs/${dir}/${name}`;
  },

  getInvitationImg(name) {
    return `${okGlobal.cdnBaseUrl}/cdn/assets/imgs/invited/${name}.png`;
  },
  /**
   *
   * @param {string} dir
   * @param {string} name
   * @returns {string} url
   */
  getAssetsIWithPng(dir, name, ver) {
    const param = ver ? `?v=${ver}` : '';
    return `${okGlobal.cdnBaseUrl}/cdn/assets/imgs/${dir}/${name}.png${param}`;
  },

  /**
   * handle request error message
   * @param name
   * @returns {*}
   */
  handleRequestMessage(err) {
    // if (err.code == MAINTENANCE_CODE) {
    //   return;
    // }
    Message.error(err.msg);
  },

  /**
   * 对邮箱或手机号做脱敏处理
   * @param {string} code
   * @returns {string} code
   */
  wrapperPrivacy(code) {
    if (code.includes('@')) {
      const [prefix, suffix] = code.split('@');
      return `${prefix.slice(0, 3)}****@${suffix}`;
    }
    return `${code.slice(0, 3)}****${code.slice(-4)}`;
  },

  isVerifyMethodEnableNormal(array) {
    const data = {
      tradePwd: foundElement(array, TRADEPASSWORD),
      email: foundElement(array, EMAIL),
      google: foundElement(array, GOOGLE),
      sms: foundElement(array, SMS),
    };
    return data;
  },

  isVerifyMethodEnableSpecial(array) {
    const data = {
      showLoginPwd: foundElement(array, LOGINPASSWORD),
      showTradePwd: foundElement(array, TRADEPASSWORD),
      showEmail: foundElement(array, EMAIL),
      showGoogle: foundElement(array, GOOGLE),
      showSms: foundElement(array, SMS),
    };
    return data;
  },

  travelRuleTipsRender({ content, links }) {
    const sortedLinkTexts = Object.keys(links).sort(
      (a, b) => b.length - a.length
    );

    const linkRegex = new RegExp(
      `(${sortedLinkTexts.map((text) => this.escapeRegExp(text)).join('|')})`,
      'g'
    );

    const parts = content.split(linkRegex);

    return (
      <div style={{ whiteSpace: 'pre-line' }}>
        {parts.map((part, i) => {
          if (links[part]) {
            const href = links[part];
            return (
              <span
                key={i}
                style={{
                  cursor: 'pointer',
                  fontWeight: 500,
                  textDecoration: 'underline',
                }}
                onClick={() => window.open(href, '_blank')}
              >
                {part}
              </span>
            );
          } else {
            return <span key={i}>{part}</span>;
          }
        })}
      </div>
    );
  },

  escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  },
};
